import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy, isEverythingSetup } from '@/utils/onboardingUtils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_eula')({
  beforeLoad: async ({ context }) => {
    const isOrgAdmin = context.auth?.isAdmin;
    const isContentCreator = context.auth?.isContentCreator;
    const isContentCreatorOnly = context.auth?.isContentCreator && context.auth?.user?.roles.length === 1;
    const { onboardingStatuses, hasUnacceptedLegalDocuments, legalAcceptanceStatuses } = useAppStore.getState();

    const isOnboardingCompleted = isEverythingSetup(onboardingStatuses, isOrgAdmin, isContentCreatorOnly);

    if (
      isOnboardingCompleted &&
      hasUnacceptedLegalDocuments &&
      isContentCreator &&
      getUnacceptedContentPolicy(legalAcceptanceStatuses)
    ) {
      throw redirect({
        to: '/creator/apply/content-policy',
      });
    }

    // EULA can be accepted through onboarding
    if (isOnboardingCompleted && !hasUnacceptedLegalDocuments) {
      if (isOrgAdmin && isOnboardingCompleted) {
        throw redirect({
          to: '/organization/dashboard',
        });
      }

      throw redirect({
        to: isContentCreatorOnly ? '/creator/profile' : '/user/dashboard',
      });
    }
  },
});
